import 'inputmask';
import 'inputmask.dependencyLib';
import 'jquery.inputmask';
import 'inputmask.extensions';
import 'inputmask.numeric.extensions';
import 'inputmask.date.extensions';
import 'inputmask.phone.extensions';
import 'inputmask.phone';
import 'inputmask.regex.extensions';

import config from './config/inputmask';

const SELECTOR = '[data-maskedinput]';

class MaskedInputs {
  constructor() {
    if ($(SELECTOR)) {
      this.initialize();
    }

    this.attachEventHandlers();
  }

  attachEventHandlers() {
    $('body').on('cocoon:after-insert', (event, $addedTask) => {
      if ($addedTask.find(SELECTOR).size() > 0) {
        this.initialize();
      }
    });
  }

  initialize() {


    for (let fieldType in config) {
      $(fieldType).size()
        ? $(fieldType).inputmask(config[fieldType])
        : undefined;
    }
  }
}

export default MaskedInputs;



// WEBPACK FOOTER //
// ./src/javascripts/MaskedInputs.js